declare namespace $ {

	export class $shm_hitalama_skills_drag extends $shm_hitalama_dragtree {
		catalog( ): $shm_hitalama_skills_catalog
		locked( ): boolean
		reversed( ): boolean
		drag_hold_delay( ): number
		drag_touch_action( ): string
		drop_root_gutter( ): boolean
	}
	
}

//# sourceMappingURL=drag.view.tree.d.ts.map